// extracted by mini-css-extract-plugin
export default {"aboutArea":"AboutTitle_aboutArea__NZdys","title":"AboutTitle_title__qiN4Y","border":"AboutTitle_border__pCvl6","details":"AboutTitle_details__Ej4fO"};